import React, { useEffect, useRef } from "react";
import { useMutation } from "@apollo/react-hooks";
import { Formik } from "formik";
import { func, number, oneOf, string } from "prop-types";

import {
  CREATE_LISTING_NOTE,
  UPDATE_LISTING_NOTE
} from "../../constants/mutations";
import * as S from "./styled";

const NoteEditor = props => {
  const textAreaRef = useRef();

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
      const { length } = textAreaRef.current.value;
      textAreaRef.current.setSelectionRange(length, length);
    }
  }, [textAreaRef]);

  const formInitialValues = {
    text: props.text
  };

  const mutationsByType = {
    create: CREATE_LISTING_NOTE,
    update: UPDATE_LISTING_NOTE
  };

  const [listingNoteMutation] = useMutation(mutationsByType[props.type]);

  const onSubmit = (values, setSubmitting) => {
    const noteText = values.text.trim();
    listingNoteMutation({
      variables: {
        listing_id: props.listing_id,
        listing_type: props.listing_type,
        note: noteText
      }
    })
      .then(() => {
        props.closeEditor();
        props.setNoteText(noteText);
      })
      .catch(errors => {
        setSubmitting(false);
        console.log("errors", errors);
      });
  };

  return (
    <Formik
      initialValues={formInitialValues}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({ handleSubmit, isSubmitting, setFieldValue, values }) => (
        <S.Form
          onSubmit={event => {
            event.preventDefault();
            handleSubmit();
          }}
        >
          <S.EditTextArea
            ref={textAreaRef}
            aria-labelledby="listing-note-text"
            id="ListingNote-textArea"
            onChange={e => setFieldValue("text", e.target.value)}
            value={values.text}
          />
          <S.SaveButton
            disabled={isSubmitting}
            onClick={event => {
              event.preventDefault();
              handleSubmit();
            }}
          >
            Save
          </S.SaveButton>
          <S.CancelButton onClick={props.closeEditor}>Cancel</S.CancelButton>
          <S.Disclaimer id="save-listing-disclaimer">
            Adding a note will also save this listing
          </S.Disclaimer>
        </S.Form>
      )}
    </Formik>
  );
};

NoteEditor.propTypes = {
  listing_id: number.isRequired,
  listing_type: oneOf(["sale", "rental"]).isRequired,
  closeEditor: func.isRequired,
  setNoteText: func.isRequired,
  text: string.isRequired,
  type: oneOf(["create", "update"]).isRequired
};

export default NoteEditor;
